/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCategoriesQuery } from '../../models/get-categories-query';
import { GetCategoriesResult } from '../../models/get-categories-result';

export interface ApiNurseryManagerCategoryGetCategoriesPost$Plain$Params {
      body?: GetCategoriesQuery
}

export function apiNurseryManagerCategoryGetCategoriesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryGetCategoriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoriesResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryGetCategoriesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCategoriesResult>;
    })
  );
}

apiNurseryManagerCategoryGetCategoriesPost$Plain.PATH = '/api/NurseryManager/Category/GetCategories';
